import { ActivityLogView } from '@services/http/clients/api-proxies';
import { CustomCellButtonComponent } from '@shared/grids/custom-cell-button/custom-cell-button.component';
import { ColDef, ValueGetterParams } from 'ag-grid-enterprise';

export const ACTIVITY_LOG_GRID_COLUMNS: ColDef<ActivityLogView>[] = [
    {
        colId: 'date',
        field: 'date',
        headerName: 'Date and time',
        cellDataType: 'dateTimeString',
        sortable: true,
        lockVisible: true
    },
    {
        colId: 'userFullName',
        field: 'userFullName',
        headerName: 'User',
        cellDataType: 'text',
        sortable: true,
        lockVisible: true
    },
    {
        colId: 'message',
        field: 'message',
        headerName: 'Event',
        cellDataType: 'text',
        sortable: false,
        tooltipValueGetter: (params) => params.value || '',
        minWidth: 200,
        lockVisible: true
    },
    {
        colId: 'parametersChanged',
        field: 'parametersChanged',
        headerName: 'Parameters changed',
        cellDataType: 'text',
        sortable: false,
        valueGetter: (params) => {
            const value = params.data?.parametersChanged;
            return Array.isArray(value) ? value.join(', ') : '';
        },
        tooltipValueGetter: (params) => {
            const value = params.data?.parametersChanged;
            return Array.isArray(value) ? value.join(', ') : '';
        },
        minWidth: 420,
        lockVisible: true
    },
    {
        colId: 'moreDetails',
        headerName: '',
        valueGetter: (params: ValueGetterParams<ActivityLogView, boolean>) => !!params.data?.changedProperties?.length,
        sortable: false,
        filter: false,
        resizable: false,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: true,
        cellRenderer: CustomCellButtonComponent,
        cellClass: 'action-cell',
        lockVisible: true
    }
];
